/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { FormStateChangeNotifier } from '../form';
var AKToggle = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.toggle' */
  '@atlaskit/toggle').then(function (module) {
    return {
      default: module.default
    };
  });
});
var AKField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var wrapperStyles = css({
  display: 'flex',
  alignItems: 'center'
});
var labelStyles = css({
  cursor: 'pointer'
});
var Toggle = function Toggle(_ref) {
  var name = _ref.name,
    defaultChecked = _ref.defaultChecked,
    testId = _ref.testId,
    label = _ref.label;
  return jsx(AKField, {
    defaultValue: defaultChecked,
    name: name
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    var onChange = fieldProps.onChange,
      value = fieldProps.value,
      id = fieldProps.id,
      isDisabled = fieldProps.isDisabled,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      toggleName = fieldProps.name;
    return jsx("div", {
      css: wrapperStyles
    }, jsx(FormStateChangeNotifier, {
      name: name,
      value: value
    }), jsx(AKToggle, {
      onChange: onChange,
      isChecked: value,
      size: "large",
      label: label,
      testId: testId,
      id: id,
      isDisabled: isDisabled,
      onBlur: onBlur,
      onFocus: onFocus,
      name: toggleName
    }), jsx("span", {
      css: labelStyles,
      onClick: function onClick() {
        return onChange(!value);
      }
    }, label));
  });
};
export default Toggle;
export var ToggleFn = function ToggleFn(_ref3) {
  var props = _ref3.props;
  var _ref4 = props,
    name = _ref4.name,
    label = _ref4.label,
    defaultChecked = _ref4.defaultChecked;
  return jsx(Toggle, {
    name: name,
    label: label,
    defaultChecked: defaultChecked
  });
};